module.exports = __webpack_public_path__ + "error-bg.629050b8bbf8098e6df7.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/assets/images/background/error-bg.jpg
// module id = ../../../../../src/assets/images/background/error-bg.jpg
// module chunks = styles